var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        id: "Layer_39",
        xmlns: "http://www.w3.org/2000/svg",
        width: "100",
        height: "100",
        viewBox: "0 0 100 100",
      },
    },
    [
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "21.165",
          y: "52.967",
          width: "57.671",
          height: "36.298",
          rx: "1",
          ry: "1",
        },
      }),
      _c("rect", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          x: "17.857",
          y: "38.304",
          width: "64.287",
          height: "14.663",
          rx: "1",
          ry: "1",
        },
      }),
      _c("line", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: { x1: "50", y1: "37.304", x2: "50", y2: "88.779" },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m57.674,47.391l-13.819-20.093c-3.639-5.196-9.832-6.119-13.289-1.493-.156.209-.304.426-.443.652s-.267.456-.383.689c-2.574,5.171,1.542,11.218,7.317,11.193h8.341",
        },
      }),
      _c("path", {
        staticStyle: {
          fill: "none",
          stroke: "#000",
          "stroke-linecap": "round",
          "stroke-miterlimit": "10",
          "stroke-width": "2px",
        },
        attrs: {
          d: "m42.286,47.391l13.819-20.093c3.639-5.196,9.832-6.119,13.289-1.493.156.209.304.426.443.652s.267.456.383.689c2.574,5.171-1.542,11.218-7.317,11.193h-2.816s-14.688,0-14.688,0",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }